import React from 'react';
// import { Redirect } from "react-router-dom";
import Cookies from 'js-cookie';
// import Highlighter from 'react-highlight-words';
// import { Link } from "react-router-dom";
import {
	Card,
	Row,
	Col,
	Input,
	Button,
	// Table,
	// Modal,
	message,
	// Alert,
	Select,
	Spin,
	Form,
	DatePicker,
} from 'antd';
import {
	// TeamOutlined,
	SearchOutlined,
	// PlusOutlined,
	// FormOutlined,
	// CloseSquareOutlined,
	// ExclamationCircleOutlined,
	// DiffOutlined,
	// RedoOutlined,
	CopyOutlined,
	PrinterOutlined
} from '@ant-design/icons';

// import axios from 'axios';

import { connect } from 'react-redux';
import {
	initHandler,
	ajaxViewHandler,
	ajaxHandler,
	setConfig,
} from "../../store/actions";

import Config from '../../Config';
import { Helmet } from "react-helmet";

import moment from "moment";

import '../../assets/laporan.css';

const configClass = {
	title: 'LAPORAN KASIR',
	apiUrl: {
		lap_kasir: 'laporan/api/kasir/',
		warna_plat: "master/api/plat",
		jenis_kendaraan: "master/api/jenis/kendaraan/",
		payment: "master/api/payment/?include_deleted=true",
		upt: "pegawai/api/upt/",
		kabupaten: "master/api/kabupaten/",
	},
	pageUrl: {
		cetak: '/laporan/kasir'
	},
	breadCrumb: [
		(
			<span>
				<CopyOutlined /> laporan
			</span>
		),
		'kasir'
	]

}

const config = new Config();

class LapKasir extends React.Component {
	formRef = React.createRef();

	constructor(props) {
		super(props);
		this.config = new Config();
		this.state = {
			loading: false,
			data: null,
			err: false,

			loadingWarnaPlat: false,
			listWarnaPlat: [],

			loadingJenisKendaraan: false,
			listJenisKendaraan: [],

			loadingPayment: false,
			listPayment: [],

			namauptppd: 'SAMSAT PALANGKARAYA',

			filter: "",

			loadingUpt: false,
			listUpt: [],

			loadingKabupaten: null,
			listKabupaten: [],
			kabupaten_id: "",

			mulai_dari: "",
            sampai_dengan: "",
			lap_kasir : ""



		}
	}

	UNSAFE_componentWillMount() {
		this.props.initHandler();
	}

	componentDidMount() {
		this.loadMasterList();
		this.initKabupatenFromCookie();
		// this.getData();
	}

	// Kabupaten yang dipilih pegawai saat login (cookie _upt) - dipakai untuk
	// auto-isi + kunci form Kabupaten pada non-superadmin, sama seperti
	// LapPenggunaanNoticeRusak.jsx.
	initKabupatenFromCookie() {
		try {
			const rawCookie = Cookies.get(this.config.get_cookie_name() + '_upt');
			if (!rawCookie) return;
			const parsed = JSON.parse(decodeURIComponent(rawCookie));
			const kabupatenId = parsed.kabupaten;
			if (!kabupatenId) return;
			this.setState({ kabupaten_id: kabupatenId });
			setTimeout(() => {
				if (this.formRef.current) {
					this.formRef.current.setFieldsValue({ kabupaten: kabupatenId });
				}
			}, 0);
			this.getMasterList({
				destination: {
					stateProgressName: 'loadingUpt',
					endPoint: configClass.apiUrl.upt + '?kabupaten=' + kabupatenId,
					stateDestination: 'listUpt',
				},
				nextDestination: null,
			});
		} catch (err) {
			console.warn('Cookie _upt tidak valid:', err);
		}
	}

	isKabupatenLocked() {
		try {
			const rawCookie = Cookies.get(this.config.get_cookie_name() + '_upt');
			if (!rawCookie) return false;
			const parsed = JSON.parse(decodeURIComponent(rawCookie));
			return Boolean(parsed.kabupaten && parsed.id);
		} catch (err) {
			return false;
		}
	}

	loadMasterList() {
		const rule = [
			{
				destination: {
					stateProgressName: "loadingJenisKendaraan",
					endPoint: configClass.apiUrl.jenis_kendaraan,
					stateDestination: "listJenisKendaraan",
				},
				nextDestination: {
					stateProgressName: "loadingWarnaPlat",
					endPoint: configClass.apiUrl.warna_plat,
					stateDestination: "listWarnaPlat",
					next: null,
				},
			},
			{
				destination: {
					stateProgressName: "loadingPayment",
					endPoint: configClass.apiUrl.payment,
					stateDestination: "listPayment",
				},
				nextDestination: {
					stateProgressName: "loadingUpt",
					endPoint: configClass.apiUrl.upt,
					stateDestination: "listUpt",
					next: null,
				},
			},
			{
				destination: {
					stateProgressName: "loadingKabupaten",
					endPoint: configClass.apiUrl.kabupaten,
					stateDestination: "listKabupaten",
				},
				nextDestination: null,
			}
		];

		this.setState({
			errComponent: false,
		});

		rule.map((item, index) => {
			if (index == rule.length - 1) {
				this.getMasterList(item, true);
			} else {
				this.getMasterList(item);
			}
		});
	}

	async getMasterList(rule, isFinal = false) {
		var destination = rule.destination;
		var nextDestination = rule.nextDestination;
		this.setState({ [destination.stateProgressName]: true });
		this.props
			.ajaxViewHandler("get", destination.endPoint)
			.then(() => {
				const data = this.props.responseMsg;
				if (this.props.isSuccess) {
					if (data.count != undefined) {
						let newState = null;
						if (this.state[destination.stateDestination].length == 0) {
							newState = data;
						} else {
							if (destination.stateProgressName.includes("_searching")) {
								newState = data;
							} else {
								const oldState = this.state[destination.stateDestination];
								newState = {
									count: data.count,
									next: data.next,
									previous: data.previous,
									results: [...oldState.results, ...data.results],
								};
							}
						}
						this.setState({
							[destination.stateDestination]: newState,
						});
					} else if (data.results != undefined) {
						this.setState({
							[destination.stateDestination]: data.results,
						});
					} else {
						if (Array.isArray(data)) {
							this.setState({
								[destination.stateDestination]: data,
							});
						} else {
							this.setState({
								[destination.stateDestination]: [data],
							});
						}
					}
					if (isFinal) {
						if (this.props.match.params.id != undefined) {
							// this.preview(this.props.match.params.id);
						}
					}
				} else {
					this.setState({
						errComponent: true,
					});
				}
				this.setState({ [destination.stateProgressName]: false });
			})
			.catch((response) => {
				//console.log('gagal_get_master', response);
				message.error({
					content: "gagal request data, coba lagi",
					duration: 2,
					key: "toast",
				});
				this.setState({
					errTitle: "gagal request data master",
					errMsg: response,
				});
				this.setState({ [destination.stateProgressName]: false });
			});
		//next function
		if (nextDestination != null) {
			const next = {
				destination: {
					stateProgressName: nextDestination.stateProgressName,
					endPoint: nextDestination.endPoint,
					stateDestination: nextDestination.stateDestination,
				},
				nextDestination: nextDestination.next,
			};
			this.getMasterList(next);
		}
	}

	generateSelect(stateName, url, key, value, keyDisplay = "") {
		return this.state["loading" + stateName] ? (
			<img src={process.env.PUBLIC_URL + "/loading_crop.gif"} height="50" />
		) : (
			<Select
				showSearch
				placeholder={"Cari / Pilih " + stateName}
				disabled={stateName === "Kabupaten" && this.isKabupatenLocked()}
				optionFilterProp="children"
				onSearch={(val) => {
					const sep = url.includes('?') ? '&' : '?';
					let endPoint = url + sep + "search=" + val;
					if (stateName === "Upt") {
						endPoint = `${url}${sep}kabupaten=${this.state.kabupaten_id}&search=${val}`;
					}
					const rule = {
						destination: {
							stateProgressName: "loading" + stateName + "_searching",
							endPoint,
							stateDestination: "list" + stateName,
						},
						nextDestination: null,
					};
					this.getMasterList(rule);
				}}
				onPopupScroll={(e) => {
					e.persist();
					let target = e.target;
					if (target.scrollTop + target.offsetHeight == target.scrollHeight) {
						if (
							this.state["list" + stateName].next != undefined &&
							this.state["list" + stateName].next != null
						) {
							const rule = {
								destination: {
									stateProgressName: "loading" + stateName + "Paging",
									endPoint: this.state["list" + stateName].next,
									stateDestination: "list" + stateName,
								},
								nextDestination: null,
							};
							this.getMasterList(rule);
						}
					}
				}}
				allowClear
				style={{
					width: "100%",
				}}
				onChange={(val) => {
					if (stateName == "Kabupaten") {
						this.setState({ kabupaten_id: val }, () => {
							const rule = {
								destination: {
									stateProgressName: "loadingUpt",
									endPoint: configClass.apiUrl.upt + "?kabupaten=" + val,
									stateDestination: "listUpt",
								},
								nextDestination: null,
							};
							this.getMasterList(rule);
						});
					}
				}}
				size={"small"}
			>
				{this.state["loading" + stateName + "_searching"] == true && (
					<Select.Option value="">
						<Spin size="small" />
					</Select.Option>
				)}
				{this.state["list" + stateName].count != undefined
					? this.state["list" + stateName].results.map((item) => (
						<Select.Option value={item[key]}>
							{keyDisplay == ""
								? item[key] + " - " + item[value]
								: item[keyDisplay] + " - " + item[value]}
						</Select.Option>
					))
					: this.state["list" + stateName].map((item) => (
						<Select.Option value={item[key]}>
							{keyDisplay == ""
								? item[key] + " - " + item[value]
								: item[keyDisplay] + " - " + item[value]}
						</Select.Option>
					))}
				{this.state["list" + stateName] != undefined &&
					this.state["list" + stateName].next != undefined && (
						<Select.Option value="">
							<Spin size="small" />
						</Select.Option>
					)}
			</Select>
		);
	}

	handleSubmit = (values) => {
		var filter = "";
		for (var key in values) {
			if (values[key] != undefined) {
				if (filter == "") {
					filter = "?" + key + "=" + values[key];
				} else {
					filter += "&" + key + "=" + values[key];
				}
			}
		}
		this.setState({
			filter: filter
		});
		this.getData(filter)
	};

	async getData(filter) {
		message.loading({ content: 'Menampilkan laporan...', duration: 0, key: 'toast' });
		this.setState({
			loading: true,
			err: false,
			data: null,
		});

		// this.props.ajaxViewHandler('get', configClass.apiUrl.data+"?warna_plat=1&jenis_kendaraan&roda=2&mulai_dari=23-10-2020&sampai_dengan=23-10-2021")
		this.props.ajaxViewHandler('get', configClass.apiUrl.lap_kasir + filter)
			.then(() => {
				const data = this.props.responseMsg;
				if (this.props.isSuccess) {
					message.destroy();
					this.setState({
						loading: false,
						data: data,
						err: false
					});
					setTimeout(function () {
						// window.print();

					}, 1000);
				} else {
					const errTitle = 'error get laporan';
					this.setState({
						loading: false,
						data: null,
						err: true,
						errMsg: this.props.responseMsg
					});
					message.error({ content: errTitle, duration: 2, key: 'toast' });
				}
			}).catch((response) => {
				this.setState({
					loading: false,
					data: null,
					err: true,
					errMsg: 'unknown response'
				});
				console.log('gagal_get_laporan', response);
				message.error({ content: 'gagal request data, coba lagi', duration: 2, key: 'toast' });
			});
	}

	handlePrint = () => {
		const printEl = document.querySelector('.lap-kasir-print-only');
		if (!printEl) return;

		// Catat posisi asli di DOM agar bisa dikembalikan
		const parent  = printEl.parentNode;
		const nextSib = printEl.nextSibling;

		// Pindahkan print section langsung ke body &  tampilkan
		printEl.style.display = 'block';
		document.body.appendChild(printEl);

		// Sembunyikan semua elemen lain yang merupakan child langsung body
		// (termasuk #root / layout app) agar tidak ada halaman ke-2
		const siblings = Array.from(document.body.children).filter(el => el !== printEl);
		siblings.forEach(el => { el.style.display = 'none'; });

		window.print();

		// Kembalikan semua ke posisi & tampilan semula
		siblings.forEach(el => { el.style.display = ''; });
		if (nextSib) {
			parent.insertBefore(printEl, nextSib);
		} else {
			parent.appendChild(printEl);
		}
		printEl.style.display = '';
	}

	render() {
		const { data, loading } = this.state;
		const d    = data?.data;
		const foot = data?.footer;

		const rp  = (v) => (v != null ? Number(v).toLocaleString('id') : '0');
		const fmt = (v) => `Rp ${rp(v)}`;

		// ── Kalkulasi subtotal ─────────────────────────────────────
		const totalBapenda    = d ? (d.pkb.jumlah + d.bbnkbi.jumlah + d.bbnkbii.jumlah) : 0;
		const totalOpsen      = d ? (d.opsen_pkb.jumlah + d.opsen_bbnkb.jumlah) : 0;
		const totalKepolisian = d ? (d.swdkllj.jumlah + d.adm_stnk.jumlah + d.adm_tnkb.jumlah) : 0;
		const totalBbnkb      = d ? (d.bbnkbi.jumlah + d.bbnkbii.jumlah) : 0;

		// ── Design tokens ──────────────────────────────────────────
		const NAVY     = '#0f2847';
		const NAVY_MID = '#1a3a6b';

		// ── Helper: KPI card ───────────────────────────────────────
		const KpiCard = ({ icon, label, value, accent, sub }) => (
			<div style={{
				background: '#fff', borderRadius: 14, padding: '18px 20px',
				border: `1px solid ${accent}22`, boxShadow: `0 2px 12px ${accent}14`,
				display: 'flex', flexDirection: 'column', gap: 6, flex: 1, minWidth: 0,
			}}>
				<div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
					<div style={{
						width: 34, height: 34, borderRadius: 9,
						background: `${accent}18`, display: 'flex',
						alignItems: 'center', justifyContent: 'center', fontSize: 16, flexShrink: 0,
					}}>{icon}</div>
					<span style={{ fontSize: 11, color: '#64748b', fontWeight: 600, textTransform: 'uppercase', letterSpacing: .8 }}>{label}</span>
				</div>
				<div style={{ fontSize: 18, fontWeight: 900, color: accent, fontFamily: 'monospace', lineHeight: 1.1 }}>
					{fmt(value)}
				</div>
				{sub && <div style={{ fontSize: 10, color: '#94a3b8' }}>{sub}</div>}
			</div>
		);

		// ── Helper: section card ───────────────────────────────────
		const SecCard = ({ dot, title, accent, rows, total, totalLabel }) => (
			<div style={{
				background: '#fff', borderRadius: 14, overflow: 'hidden',
				border: '1px solid #e2e8f0', boxShadow: '0 2px 10px rgba(15,40,71,0.06)', marginBottom: 12,
			}}>
				<div style={{
					background: `${accent}0e`, padding: '10px 18px',
					display: 'flex', alignItems: 'center', gap: 8,
					borderBottom: `1px solid ${accent}22`,
				}}>
					<span style={{ fontSize: 16 }}>{dot}</span>
					<span style={{ fontSize: 12, fontWeight: 700, color: accent, letterSpacing: 1, textTransform: 'uppercase', flex: 1 }}>{title}</span>
					<span style={{ fontSize: 13, fontWeight: 800, color: accent, fontFamily: 'monospace' }}>{fmt(total)}</span>
				</div>
				{/* Tabel header */}
				<div style={{ display: 'grid', gridTemplateColumns: '1fr repeat(4, minmax(90px,auto))', gap: 8, padding: '6px 18px', background: '#f8fafc', borderBottom: '1px solid #e2e8f0' }}>
					{['Komponen', 'Pokok', 'Tunggakan', 'Denda', 'Jumlah'].map((h, i) => (
						<span key={i} style={{ fontSize: 10, color: '#94a3b8', fontWeight: 700, textTransform: 'uppercase', textAlign: i === 0 ? 'left' : 'right' }}>{h}</span>
					))}
				</div>
				{rows.map((row, i) => (
					<div key={i} style={{
						display: 'grid', gridTemplateColumns: '1fr repeat(4, minmax(90px,auto))', gap: 8,
						padding: '9px 18px', borderBottom: i < rows.length - 1 ? '1px solid #f1f5f9' : 'none', alignItems: 'center',
					}}>
						<span style={{ fontSize: 12, color: '#334155', fontWeight: 500 }}>{row.label}</span>
						<span style={{ fontSize: 12, color: '#475569', textAlign: 'right', fontFamily: 'monospace' }}>{rp(row.pokok)}</span>
						<span style={{ fontSize: 12, color: '#475569', textAlign: 'right', fontFamily: 'monospace' }}>{rp(row.tunggakan)}</span>
						<span style={{ fontSize: 12, color: row.denda > 0 ? '#ef4444' : '#cbd5e1', textAlign: 'right', fontFamily: 'monospace' }}>{rp(row.denda)}</span>
						<span style={{ fontSize: 12, fontWeight: 700, color: '#1e293b', textAlign: 'right', fontFamily: 'monospace' }}>{rp(row.jumlah)}</span>
					</div>
				))}
				<div style={{
					display: 'flex', justifyContent: 'space-between', alignItems: 'center',
					padding: '10px 18px', background: `${accent}08`, borderTop: `2px solid ${accent}30`,
				}}>
					<span style={{ fontSize: 12, fontWeight: 700, color: accent }}>{totalLabel || `TOTAL ${title}`}</span>
					<span style={{ fontSize: 14, fontWeight: 900, color: accent, fontFamily: 'monospace' }}>{fmt(total)}</span>
				</div>
			</div>
		);

		// ── Helper: simple 2-col section (opsen, adm) ─────────────
		const SimpleSecCard = ({ dot, title, accent, rows, total }) => (
			<div style={{
				background: '#fff', borderRadius: 14, overflow: 'hidden',
				border: '1px solid #e2e8f0', boxShadow: '0 2px 10px rgba(15,40,71,0.06)', marginBottom: 12,
			}}>
				<div style={{
					background: `${accent}0e`, padding: '10px 18px',
					display: 'flex', alignItems: 'center', gap: 8, borderBottom: `1px solid ${accent}22`,
				}}>
					<span style={{ fontSize: 16 }}>{dot}</span>
					<span style={{ fontSize: 12, fontWeight: 700, color: accent, letterSpacing: 1, textTransform: 'uppercase', flex: 1 }}>{title}</span>
					<span style={{ fontSize: 13, fontWeight: 800, color: accent, fontFamily: 'monospace' }}>{fmt(total)}</span>
				</div>
				{rows.map((row, i) => (
					<div key={i} style={{
						display: 'flex', justifyContent: 'space-between', alignItems: 'center',
						padding: '9px 18px', borderBottom: i < rows.length - 1 ? '1px solid #f1f5f9' : 'none',
					}}>
						<span style={{ fontSize: 12, color: '#334155', fontWeight: 500 }}>{row.label}</span>
						<span style={{ fontSize: 12, fontWeight: 700, color: '#1e293b', fontFamily: 'monospace' }}>{fmt(row.value)}</span>
					</div>
				))}
				<div style={{
					display: 'flex', justifyContent: 'space-between', alignItems: 'center',
					padding: '10px 18px', background: `${accent}08`, borderTop: `2px solid ${accent}30`,
				}}>
					<span style={{ fontSize: 12, fontWeight: 700, color: accent }}>TOTAL {title}</span>
					<span style={{ fontSize: 14, fontWeight: 900, color: accent, fontFamily: 'monospace' }}>{fmt(total)}</span>
				</div>
			</div>
		);

		const labelFilter = (txt) => (
			<span style={{ fontSize: 11, fontWeight: 600, color: '#475569', textTransform: 'uppercase', letterSpacing: .5 }}>{txt}</span>
		);

		return (
			<div>
				<Helmet>
					<title>{configClass.title + ' | ' + config.get_site_info().name}</title>
				</Helmet>
				{/* ── Konten layar: disembunyikan saat print ── */}
				<div className="lap-kasir-screen">

				<div className="card">
					<Row className="isi" gutter={[0, 14]}>

						{/* ══════════════════ FILTER PANEL ══════════════════ */}
						<Col span={24}>
							<div style={{ background: '#fff', borderRadius: 14, overflow: 'hidden', border: '1px solid #e2e8f0', boxShadow: '0 2px 12px rgba(15,40,71,0.07)' }}>

								{/* Header dark navy */}
								<div style={{ background: `linear-gradient(135deg, ${NAVY} 0%, ${NAVY_MID} 100%)`, padding: '16px 20px' }}>
									<div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
										<div style={{ width: 36, height: 36, background: 'rgba(251,191,36,0.15)', borderRadius: 10, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 18 }}>📋</div>
										<div>
											<div style={{ fontSize: 14, fontWeight: 700, color: '#fff', letterSpacing: .3 }}>Laporan Kasir</div>
											<div style={{ fontSize: 11, color: '#64748b' }}>Rekapitulasi penerimaan berdasarkan filter yang dipilih</div>
										</div>
									</div>
								</div>

								{/* Filter form */}
								<Form layout="vertical" name="fdata" onFinish={this.handleSubmit} size="small" ref={this.formRef}
									disabled={loading}
									style={{ padding: '18px 20px 14px' }}
								>
									<div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: '0 16px' }}>

										<Form.Item name="kabupaten" label={labelFilter('Kabupaten')} style={{ marginBottom: 10 }}>
											{this.generateSelect('Kabupaten', configClass.apiUrl.kabupaten, 'id', 'name')}
										</Form.Item>

										<Form.Item name="upt" label={labelFilter('UPT')} style={{ marginBottom: 10 }}>
											{this.generateSelect('Upt', configClass.apiUrl.upt, 'id', 'nama', 'id')}
										</Form.Item>

										<Form.Item name="jenis_kendaraan" label={labelFilter('Jenis Kendaraan')} style={{ marginBottom: 10 }}>
											{this.generateSelect('JenisKendaraan', configClass.apiUrl.jenis_kendaraan, 'id', 'nama', 'kode')}
										</Form.Item>

										<Form.Item name="warna_plat" label={labelFilter('Warna Plat')} style={{ marginBottom: 10 }}>
											{this.generateSelect('WarnaPlat', configClass.apiUrl.warna_plat, 'id', 'nama', 'kode')}
										</Form.Item>

										<Form.Item name="roda" label={labelFilter('Jumlah Roda')} style={{ marginBottom: 10 }}>
											<Input placeholder="cth: 2" size="small" style={{ borderRadius: 8 }} />
										</Form.Item>

										<Form.Item name="payment_type" label={labelFilter('Jenis Pembayaran')} style={{ marginBottom: 10 }}>
											{this.generateSelect('Payment', configClass.apiUrl.payment, 'id', 'nama', 'kode')}
										</Form.Item>

										<Form.Item name="mulai_dari_picker" label={labelFilter('Periode Mulai')} style={{ marginBottom: 10 }}>
											<DatePicker
												placeholder="dd-mm-yyyy" format="DD-MM-YYYY"
												style={{ width: '100%', borderRadius: 8 }}
												onChange={(date, dateString) => {
													this.formRef.current.setFieldsValue({ mulai_dari: dateString, lap_kasir: 'lap_kasir' });
													this.setState({ mulai_dari: dateString, lap_kasir: 'lap_kasir' });
												}}
											/>
										</Form.Item>

										<Form.Item name="sampai_dengan_picker" label={labelFilter('Sampai Dengan')} style={{ marginBottom: 10 }}>
											<DatePicker
												placeholder="dd-mm-yyyy" format="DD-MM-YYYY"
												style={{ width: '100%', borderRadius: 8 }}
												onChange={(date, dateString) => {
													this.formRef.current.setFieldsValue({ sampai_dengan: dateString });
													this.setState({ sampai_dengan: dateString });
												}}
											/>
										</Form.Item>

									</div>

									{/* Hidden fields */}
									<Form.Item name="lap_kasir" style={{ display: 'none' }}><Input type="hidden" /></Form.Item>
									<Form.Item name="mulai_dari" style={{ display: 'none' }}><Input type="hidden" /></Form.Item>
									<Form.Item name="sampai_dengan" style={{ display: 'none' }}><Input type="hidden" /></Form.Item>

									{/* Action buttons */}
									<div style={{ display: 'flex', gap: 10, paddingTop: 4 }}>
										<Button
											key="btn-proses" loading={loading} type="primary" htmlType="submit"
											disabled={loading} icon={!loading && <SearchOutlined />}
											style={{
												borderRadius: 9, height: 36, paddingInline: 20, fontWeight: 700,
												background: NAVY, borderColor: NAVY,
											}}
										>
											Proses Laporan
										</Button>
										{data != null && (
											<Button
												key="btn-cetak" loading={loading} htmlType="button"
												disabled={loading} icon={!loading && <PrinterOutlined />}
												style={{ borderRadius: 9, height: 36, paddingInline: 20, fontWeight: 600 }}
												onClick={this.handlePrint}
											>
												Cetak
											</Button>
										)}
									</div>
								</Form>
							</div>
						</Col>

						{/* ══════════════════ LOADING STATE ══════════════════ */}
						{loading && (
							<Col span={24}>
								<div style={{ background: '#fff', borderRadius: 14, padding: '28px', textAlign: 'center', border: '1px solid #e2e8f0' }}>
									<Spin size="large" />
									<div style={{ marginTop: 12, color: '#64748b', fontSize: 13 }}>Memproses laporan, mohon tunggu...</div>
								</div>
							</Col>
						)}

						{/* ══════════════════ HASIL LAPORAN ══════════════════ */}
						{data != null && !loading && (
							<>
								{/* ── Judul periode ── */}
								<Col span={24}>
									<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 8 }}>
										<div>
											<div style={{ fontSize: 15, fontWeight: 700, color: NAVY }}>Rekapitulasi Penerimaan</div>
											<div style={{ fontSize: 12, color: '#64748b' }}>
												{this.state.mulai_dari === this.state.sampai_dengan
													? this.state.mulai_dari
													: `${this.state.mulai_dari} s/d ${this.state.sampai_dengan}`}
												{data.ttd?.kanan?.nama && ` · ${data.ttd.kanan.nama}`}
											</div>
										</div>
										<div style={{ fontSize: 11, color: '#94a3b8' }}>
											{foot && `Posting: ${moment(foot.posting).format('DD-MM-YYYY HH:mm:ss')}`}
										</div>
									</div>
								</Col>

								{/* ── KPI Summary Cards ── */}
								<Col span={24}>
									<div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
										<div style={{
											background: `linear-gradient(135deg, ${NAVY} 0%, ${NAVY_MID} 100%)`,
											borderRadius: 14, padding: '18px 22px', flex: '1 1 200px', minWidth: 0,
											boxShadow: '0 4px 18px rgba(15,40,71,0.2)',
										}}>
											<div style={{ fontSize: 10, color: '#94a3b8', fontWeight: 700, textTransform: 'uppercase', letterSpacing: 1, marginBottom: 8 }}>💰 TOTAL PENERIMAAN</div>
											<div style={{ fontSize: 22, fontWeight: 900, color: '#fbbf24', fontFamily: 'monospace', lineHeight: 1 }}>{fmt(d.total)}</div>
											{foot && <div style={{ fontSize: 10, color: '#475569', marginTop: 8 }}>{foot.online.toLocaleString('id')} transaksi online</div>}
										</div>
										<KpiCard icon="🏛️" label="Total Bapenda"    value={totalBapenda}    accent="#1d4ed8" sub="PKB + BBN KB I + BBN KB II" />
										<KpiCard icon="🔷" label="Total Opsen"       value={totalOpsen}      accent="#7c3aed" sub="Opsen PKB + Opsen BBNKB" />
										<KpiCard icon="⚖️" label="Total Kepolisian"  value={totalKepolisian} accent="#0891b2" sub="SWDKLLJ + ADM STNK + ADM TNKB" />
									</div>
								</Col>

								{/* ── PKB ── */}
								<Col span={24}>
									<SecCard
										dot="🔵" title="PKB" accent="#1d4ed8"
										total={d.pkb.jumlah}
										rows={[
											{ label: 'Pokok PKB',           pokok: d.pkb.pokok,           tunggakan: 0,               denda: 0,               jumlah: d.pkb.pokok },
											{ label: 'Tunggakan PKB',       pokok: 0,                     tunggakan: d.pkb.tunggakan, denda: 0,               jumlah: d.pkb.tunggakan },
											{ label: 'Denda PKB',           pokok: 0,                     tunggakan: 0,               denda: d.pkb.denda,     jumlah: d.pkb.denda },
											{ label: 'Denda Tunggakan PKB', pokok: 0,                     tunggakan: 0,               denda: d.pkb.denda_tunggakan, jumlah: d.pkb.denda_tunggakan },
										]}
									/>
								</Col>

								{/* ── BBNKB ── */}
								<Col span={24}>
									<div style={{ background: '#fff', borderRadius: 14, overflow: 'hidden', border: '1px solid #e2e8f0', boxShadow: '0 2px 10px rgba(15,40,71,0.06)', marginBottom: 12 }}>
										{/* Header */}
										<div style={{ background: '#7c3aed0e', padding: '10px 18px', display: 'flex', alignItems: 'center', gap: 8, borderBottom: '1px solid #7c3aed22' }}>
											<span style={{ fontSize: 16 }}>🟣</span>
											<span style={{ fontSize: 12, fontWeight: 700, color: '#7c3aed', letterSpacing: 1, textTransform: 'uppercase', flex: 1 }}>BBN KB (I & II)</span>
											<span style={{ fontSize: 13, fontWeight: 800, color: '#7c3aed', fontFamily: 'monospace' }}>{fmt(totalBbnkb)}</span>
										</div>
										{/* Grid header */}
										<div style={{ display: 'grid', gridTemplateColumns: '1fr repeat(4, minmax(90px,auto))', gap: 8, padding: '6px 18px', background: '#f8fafc', borderBottom: '1px solid #e2e8f0' }}>
											{['Komponen', 'Pokok', 'Tunggakan', 'Denda', 'Jumlah'].map((h, i) => (
												<span key={i} style={{ fontSize: 10, color: '#94a3b8', fontWeight: 700, textTransform: 'uppercase', textAlign: i === 0 ? 'left' : 'right' }}>{h}</span>
											))}
										</div>
										{[
											{ label: 'Pokok BBN I',           p: d.bbnkbi.pokok,  t: 0,                  de: 0,               j: d.bbnkbi.pokok },
											{ label: 'Tunggakan BBN I',       p: 0,               t: d.bbnkbi.tunggakan, de: 0,               j: d.bbnkbi.tunggakan },
											{ label: 'Denda BBN I',           p: 0,               t: 0,                  de: d.bbnkbi.denda,  j: d.bbnkbi.denda },
											{ label: 'Denda Tunggakan BBN I', p: 0,               t: 0,                  de: d.bbnkbi.denda_tunggakan, j: d.bbnkbi.denda_tunggakan },
											{ label: 'Pokok BBN II',          p: d.bbnkbii.pokok, t: 0,                  de: 0,               j: d.bbnkbii.pokok },
											{ label: 'Tunggakan BBN II',      p: 0,               t: d.bbnkbii.tunggakan,de: 0,               j: d.bbnkbii.tunggakan },
											{ label: 'Denda BBN II',          p: 0,               t: 0,                  de: d.bbnkbii.denda, j: d.bbnkbii.denda },
											{ label: 'Denda Tunggakan BBN II',p: 0,               t: 0,                  de: d.bbnkbii.denda_tunggakan, j: d.bbnkbii.denda_tunggakan },
										].map((row, i) => (
											<div key={i} style={{ display: 'grid', gridTemplateColumns: '1fr repeat(4, minmax(90px,auto))', gap: 8, padding: '8px 18px', borderBottom: '1px solid #f1f5f9', alignItems: 'center' }}>
												<span style={{ fontSize: 12, color: '#334155', fontWeight: 500 }}>{row.label}</span>
												<span style={{ fontSize: 12, color: '#475569', textAlign: 'right', fontFamily: 'monospace' }}>{rp(row.p)}</span>
												<span style={{ fontSize: 12, color: '#475569', textAlign: 'right', fontFamily: 'monospace' }}>{rp(row.t)}</span>
												<span style={{ fontSize: 12, color: row.de > 0 ? '#ef4444' : '#cbd5e1', textAlign: 'right', fontFamily: 'monospace' }}>{rp(row.de)}</span>
												<span style={{ fontSize: 12, fontWeight: 700, color: '#1e293b', textAlign: 'right', fontFamily: 'monospace' }}>{rp(row.j)}</span>
											</div>
										))}
										{/* Subtotal BBN I & II */}
										{[
											{ label: 'Subtotal BBN KB I',  val: d.bbnkbi.jumlah },
											{ label: 'Subtotal BBN KB II', val: d.bbnkbii.jumlah },
										].map((row, i) => (
											<div key={i} style={{ display: 'flex', justifyContent: 'space-between', padding: '7px 18px', background: '#faf5ff', borderTop: i === 0 ? '1px solid #e9d5ff' : 'none' }}>
												<span style={{ fontSize: 11, fontWeight: 600, color: '#6d28d9' }}>{row.label}</span>
												<span style={{ fontSize: 12, fontWeight: 700, color: '#6d28d9', fontFamily: 'monospace' }}>{fmt(row.val)}</span>
											</div>
										))}
										<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 18px', background: '#7c3aed08', borderTop: '2px solid #7c3aed30' }}>
											<span style={{ fontSize: 12, fontWeight: 700, color: '#7c3aed' }}>TOTAL BBN KB</span>
											<span style={{ fontSize: 14, fontWeight: 900, color: '#7c3aed', fontFamily: 'monospace' }}>{fmt(totalBbnkb)}</span>
										</div>
									</div>
								</Col>

								{/* ── SP3 / SPK ── */}
								<Col span={24}>
									<SimpleSecCard
										dot="📄" title="SP3 / SPK" accent="#0891b2"
										total={d.total_sp3}
										rows={[
											{ label: 'SP3/SPK Kendaraan Baru',   value: d.total_sp3_baru },
											{ label: 'SP3/SPK Kendaraan Mutasi', value: d.total_sp3_mutasi },
										]}
									/>
								</Col>

								{/* ── Opsen ── */}
								<Col span={24}>
									<div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px,1fr))', gap: 12, marginBottom: 12 }}>
										<SimpleSecCard
											dot="🔶" title="Opsen PKB" accent="#b45309"
											total={d.opsen_pkb.jumlah}
											rows={[
												{ label: 'Opsen Pokok PKB', value: d.opsen_pkb.pokok },
												{ label: 'Opsen Denda PKB', value: d.opsen_pkb.denda },
											]}
										/>
										<SimpleSecCard
											dot="🔷" title="Opsen BBNKB" accent="#0891b2"
											total={d.opsen_bbnkb.jumlah}
											rows={[
												{ label: 'Opsen Pokok BBNKB', value: d.opsen_bbnkb.pokok },
												{ label: 'Opsen Denda BBNKB', value: d.opsen_bbnkb.denda },
											]}
										/>
									</div>
								</Col>

								{/* ── Kepolisian ── */}
								<Col span={24}>
									<div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px,1fr))', gap: 12, marginBottom: 12 }}>
										<SimpleSecCard
											dot="🛡️" title="SWDKLLJ" accent="#047857"
											total={d.swdkllj.jumlah}
											rows={[
												{ label: 'Pokok SWDKLLJ', value: d.swdkllj.pokok },
												{ label: 'Denda SWDKLLJ', value: d.swdkllj.denda },
											]}
										/>
										<SimpleSecCard
											dot="🚔" title="Administrasi Kepolisian" accent="#0f172a"
											total={d.adm_stnk.jumlah + d.adm_tnkb.jumlah}
											rows={[
												{ label: 'Administrasi STNK', value: d.adm_stnk.jumlah },
												{ label: 'Administrasi TNKB', value: d.adm_tnkb.jumlah },
											]}
										/>
									</div>
								</Col>

								{/* ── Grand Total Bar ── */}
								<Col span={24}>
									<div style={{
										background: `linear-gradient(135deg, ${NAVY} 0%, ${NAVY_MID} 100%)`,
										borderRadius: 14, padding: '20px 24px',
										display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 12,
										boxShadow: '0 4px 20px rgba(15,40,71,0.2)',
									}}>
										<div>
											<div style={{ fontSize: 11, color: '#64748b', fontWeight: 700, textTransform: 'uppercase', letterSpacing: 1, marginBottom: 6 }}>TOTAL SELURUH PENERIMAAN</div>
											<div style={{ display: 'flex', gap: 16, flexWrap: 'wrap' }}>
												{[
													{ label: 'Bapenda',    val: totalBapenda },
													{ label: 'Opsen',      val: totalOpsen },
													{ label: 'Kepolisian', val: totalKepolisian },
													{ label: 'SP3/SPK',   val: d.total_sp3 },
												].map((s, i) => (
													<div key={i} style={{ fontSize: 11, color: '#94a3b8' }}>
														{s.label}: <span style={{ color: '#cbd5e1', fontWeight: 600 }}>{fmt(s.val)}</span>
													</div>
												))}
											</div>
										</div>
										<div style={{ fontSize: 28, fontWeight: 900, color: '#fbbf24', fontFamily: 'monospace' }}>{fmt(d.total)}</div>
									</div>
								</Col>

								{/* ── Footer info ── */}
								{foot && (
									<Col span={24}>
										<div style={{
											display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px,1fr))',
											gap: 10, background: '#f8fafc', borderRadius: 12, padding: '14px 18px',
											border: '1px solid #e2e8f0', fontSize: 11,
										}}>
											{[
												{ icon: '🕐', label: 'Waktu Posting', val: moment(foot.posting).format('DD-MM-YYYY HH:mm:ss') },
												{ icon: '🖨️', label: 'Waktu Cetak',   val: moment(foot.printed).format('DD-MM-YYYY HH:mm:ss') },
												{ icon: '🌐', label: 'Transaksi Online', val: foot.online.toLocaleString('id') + ' transaksi' },
												{ icon: '💵', label: 'Total Online',   val: fmt(foot.total) },
											].map((f, i) => (
												<div key={i} style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
													<span style={{ color: '#94a3b8', fontWeight: 600, textTransform: 'uppercase', letterSpacing: .5 }}>{f.icon} {f.label}</span>
													<span style={{ color: '#334155', fontWeight: 700, fontSize: 12 }}>{f.val}</span>
												</div>
											))}
										</div>
									</Col>
								)}
							</>
						)}

					</Row>
				</div>
				</div>{/* end lap-kasir-screen */}

				{/* ── Print-only section: format resmi seperti LapKasirCetak ── */}
				{data != null && (
					<div className="lap-kasir-print-only kertas-laporan">
						<div className="judul-laporan" style={{ borderBottom: 'double 5px #000000' }}>
							REKAPITULASI PENERIMAAN<br />
							TANGGAL : {this.state.mulai_dari === this.state.sampai_dengan
								? this.state.mulai_dari
								: `${this.state.mulai_dari} s/d ${this.state.sampai_dengan}`}
							<span style={{ marginLeft: 10 }}>PEMERINTAH PROVINSI KALIMANTAN TENGAH</span>
							<div className="teks-kanan">{data.ttd?.kanan?.nama}</div>
						</div>

						<table className="laporan-table" cellPadding="1" style={{ border: '1px dotted #000000', width: '100%' }}>
							<tbody>
							<tr><td>1. POKOK PKB</td><td>Rp.</td><td className="teks-kanan">{rp(d.pkb.pokok)}</td></tr>
							<tr><td>2. TUNGGAKAN PKB</td><td>Rp.</td><td className="teks-kanan">{rp(d.pkb.tunggakan)}</td></tr>
							<tr><td>3. DENDA PKB</td><td>Rp.</td><td className="teks-kanan">{rp(d.pkb.denda)}</td></tr>
							<tr><td>4. DENDA TUNGGAKAN PKB</td><td>Rp.</td><td className="teks-kanan">{rp(d.pkb.denda_tunggakan)}</td></tr>
							<tr><td className="teks-kanan">TOTAL PKB</td><td>Rp.</td><td className="teks-kanan" style={{ borderTop: '1px dotted #000' }}>{rp(d.pkb.jumlah)}</td></tr>
							<tr><td colSpan={3}>&nbsp;</td></tr>
							<tr><td>5. POKOK BBN I</td><td>Rp.</td><td className="teks-kanan">{rp(d.bbnkbi.pokok)}</td></tr>
							<tr><td>6. TUNGGAKAN BBN I</td><td>Rp.</td><td className="teks-kanan">{rp(d.bbnkbi.tunggakan)}</td></tr>
							<tr><td>7. DENDA BBN I</td><td>Rp.</td><td className="teks-kanan">{rp(d.bbnkbi.denda)}</td></tr>
							<tr><td>8. DENDA TUNGGAKAN BBN I</td><td>Rp.</td><td className="teks-kanan">{rp(d.bbnkbi.denda_tunggakan)}</td></tr>
							<tr><td className="teks-kanan">TOTAL BBN I</td><td>Rp.</td><td className="teks-kanan" style={{ borderTop: '1px dotted #000' }}>{rp(d.bbnkbi.jumlah)}</td></tr>
							<tr><td colSpan={3}>&nbsp;</td></tr>
							<tr><td>9. POKOK BBN II</td><td>Rp.</td><td className="teks-kanan">{rp(d.bbnkbii.pokok)}</td></tr>
							<tr><td>10. TUNGGAKAN BBN II</td><td>Rp.</td><td className="teks-kanan">{rp(d.bbnkbii.tunggakan)}</td></tr>
							<tr><td>11. DENDA BBN II</td><td>Rp.</td><td className="teks-kanan">{rp(d.bbnkbii.denda)}</td></tr>
							<tr><td>12. DENDA TUNGGAKAN BBN II</td><td>Rp.</td><td className="teks-kanan">{rp(d.bbnkbii.denda_tunggakan)}</td></tr>
							<tr><td className="teks-kanan">TOTAL BBN II</td><td>Rp.</td><td className="teks-kanan" style={{ borderTop: '1px dotted #000' }}>{rp(d.bbnkbii.jumlah)}</td></tr>
							<tr><td colSpan={3} style={{ paddingLeft: 20 }}>REKAPITULASI BBNKB :</td></tr>
							<tr><td style={{ paddingLeft: 25 }}>BBNKB - I</td><td>Rp.</td><td className="teks-kanan">{rp(d.bbnkbi.pokok)}</td></tr>
							<tr><td style={{ paddingLeft: 25 }}>BBNKB - II</td><td>Rp.</td><td className="teks-kanan">{rp(d.bbnkbii.pokok)}</td></tr>
							<tr><td style={{ paddingLeft: 25 }}>TUNGGAKAN</td><td>Rp.</td><td className="teks-kanan">{rp(d.bbnkbi.tunggakan + d.bbnkbii.tunggakan)}</td></tr>
							<tr><td style={{ paddingLeft: 25 }}>DENDA</td><td>Rp.</td><td className="teks-kanan">{rp(d.bbnkbi.denda + d.bbnkbii.denda)}</td></tr>
							<tr><td className="teks-kanan" style={{ paddingLeft: 25 }}>TOTAL BBNKB</td><td>Rp.</td><td className="teks-kanan" style={{ borderTop: '1px dotted #000' }}>{rp(d.bbnkbi.jumlah + d.bbnkbii.jumlah)}</td></tr>
							<tr><td className="teks-kanan bold" style={{ paddingLeft: 25 }}>TOTAL BAPENDA</td><td>Rp.</td><td className="teks-kanan bold">{rp(d.pkb.jumlah + d.bbnkbi.jumlah + d.bbnkbii.jumlah)}</td></tr>
							<tr><td colSpan={3}>&nbsp;</td></tr>
							<tr><td colSpan={3} style={{ paddingLeft: 20 }}>REKAPITULASI SP3/SPK :</td></tr>
							<tr><td style={{ paddingLeft: 25 }}>SP3 / SPK KENDARAAN BARU</td><td>Rp.</td><td className="teks-kanan">{rp(d.total_sp3_baru)}</td></tr>
							<tr><td style={{ paddingLeft: 25 }}>SP3 / SPK KENDARAAN MUTASI</td><td>Rp.</td><td className="teks-kanan">{rp(d.total_sp3_mutasi)}</td></tr>
							<tr><td className="teks-kanan bold" style={{ paddingLeft: 25 }}>TOTAL SPK</td><td>Rp.</td><td className="teks-kanan bold" style={{ borderTop: '1px dotted #000' }}>{rp(d.total_sp3)}</td></tr>
							<tr><td colSpan={3}>&nbsp;</td></tr>
							<tr><td>13. OPSEN POKOK BBNKB</td><td>Rp.</td><td className="teks-kanan">{rp(d.opsen_bbnkb.pokok)}</td></tr>
							<tr><td>14. OPSEN DENDA BBNKB</td><td>Rp.</td><td className="teks-kanan">{rp(d.opsen_bbnkb.denda)}</td></tr>
							<tr><td className="teks-kanan">TOTAL OPSEN BBNKB</td><td>Rp.</td><td className="teks-kanan" style={{ borderTop: '1px dotted #000' }}>{rp(d.opsen_bbnkb.jumlah)}</td></tr>
							<tr><td colSpan={3}>&nbsp;</td></tr>
							<tr><td>15. OPSEN POKOK PKB</td><td>Rp.</td><td className="teks-kanan">{rp(d.opsen_pkb.pokok)}</td></tr>
							<tr><td>16. OPSEN DENDA PKB</td><td>Rp.</td><td className="teks-kanan">{rp(d.opsen_pkb.denda)}</td></tr>
							<tr><td className="teks-kanan">TOTAL OPSEN PKB</td><td>Rp.</td><td className="teks-kanan" style={{ borderTop: '1px dotted #000' }}>{rp(d.opsen_pkb.jumlah)}</td></tr>
							<tr><td className="teks-kanan bold" style={{ paddingLeft: 25 }}>TOTAL OPSEN</td><td>Rp.</td><td className="teks-kanan bold">{rp(d.opsen_pkb.jumlah + d.opsen_bbnkb.jumlah)}</td></tr>
							<tr><td colSpan={3}>&nbsp;</td></tr>
							<tr><td>17. POKOK SWDKLLJ</td><td>Rp.</td><td className="teks-kanan">{rp(d.swdkllj.pokok)}</td></tr>
							<tr><td>18. DENDA SWDKLLJ</td><td>Rp.</td><td className="teks-kanan">{rp(d.swdkllj.denda)}</td></tr>
							<tr><td className="teks-kanan bold">TOTAL SWDKLLJ</td><td>Rp.</td><td className="teks-kanan bold" style={{ borderTop: '1px dotted #000' }}>{rp(d.swdkllj.jumlah)}</td></tr>
							<tr><td colSpan={3}>&nbsp;</td></tr>
							<tr><td>19. ADMINISTRASI STNK</td><td>Rp.</td><td className="teks-kanan">{rp(d.adm_stnk.jumlah)}</td></tr>
							<tr><td>20. ADMINISTRASI TNKB</td><td>Rp.</td><td className="teks-kanan">{rp(d.adm_tnkb.jumlah)}</td></tr>
							<tr><td className="teks-kanan bold">TOTAL KEPOLISIAN</td><td>Rp.</td><td className="teks-kanan bold" style={{ borderTop: '1px dotted #000' }}>{rp(d.adm_stnk.jumlah + d.adm_tnkb.jumlah)}</td></tr>
							<tr><td colSpan={3}>&nbsp;</td></tr>
							<tr><td colSpan={2}></td><td style={{ borderBottom: '2px double #000' }}></td></tr>
							<tr><td className="teks-kanan bold">TOTAL SELURUH</td><td>Rp.</td><td className="teks-kanan bold">{rp(d.total)}</td></tr>
							</tbody>
						</table>

						{foot && (
							<div style={{ marginTop: 10, fontSize: 11 }}>
								<div style={{ display: 'flex', gap: 20 }}>
									<span>Posting: {moment(foot.posting).format('DD-MM-YYYY HH:mm:ss')}</span>
									<span>Printed: {moment(foot.printed).format('DD-MM-YYYY HH:mm:ss')}</span>
								</div>
								<div style={{ display: 'flex', gap: 20 }}>
									<span>Jumlah transaksi online: {foot.online.toLocaleString('id')}</span>
									<span>Total pajak online: Rp {foot.total.toLocaleString('id')}</span>
								</div>
							</div>
						)}
					</div>
				)}

			</div>
		);
	}
}

const mapStateToProps = function (state) {
	return state.configReducers
}

export default connect(
	mapStateToProps,
	{
		initHandler,
		setConfig,
		ajaxViewHandler,
		ajaxHandler
	}
)(LapKasir);